import { BaseCourse } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { CourseDetails, CourseTypeOption } from '@/jbi-shared/dto/jtms.dtos';
import {
  GroupLevelAttribute,
  GroupLevelAttributeContactsType,
  GroupLevelAttributeOption
} from '@/jbi-shared/types/jaas-group-level-attributes.types';
import { defaultApiState } from '@/store/types/general.types';
import { AxiosError } from 'axios';
import {
  CourseState,
  CourseStatusCountsDTO,
  CourseTabsNames,
  CourseTypeDTO,
  GetCoursesResponsePayload
} from './course.types';

export const courseMutations = {
  GET_COURSE_COUNT_FOR_EACH_STATUS_SUCCESS(
    state: CourseState,
    data: CourseStatusCountsDTO
  ) {
    state.apiState.getCourseCountForEachStatus = {
      ...defaultApiState,
      success: true
    };
    state.courseCountForEachStatus = data;
  },
  GET_COURSE_COUNT_FOR_EACH_STATUS_LOADING(state: CourseState) {
    state.apiState.getCourseCountForEachStatus = {
      ...defaultApiState,
      loading: true
    };
    state.courseCountForEachStatus = undefined;
  },
  GET_COURSE_COUNT_FOR_EACH_STATUS_ERROR(
    state: CourseState,
    error: AxiosError
  ) {
    state.apiState.getCourseCountForEachStatus = {
      ...defaultApiState,
      error
    };
  },

  GET_COURSE_TYPES_SUCCESS(state: CourseState, data: CourseTypeDTO[]) {
    state.apiState.getCourseTypes = {
      ...defaultApiState,
      success: true
    };
    state.courseTypes = data;
  },
  GET_COURSE_TYPES_LOADING(state: CourseState) {
    state.apiState.getCourseTypes = {
      ...defaultApiState,
      loading: true
    };
    state.courseTypes = undefined;
  },
  GET_COURSE_TYPES_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.getCourseTypes = {
      ...defaultApiState,
      error
    };
  },

  GET_COURSES_LOADING(state: CourseState) {
    state.apiState.getCourses = {
      ...defaultApiState,
      loading: true
    };
    state.courses = undefined;
  },
  GET_COURSES_SUCCESS(state: CourseState, data: GetCoursesResponsePayload) {
    state.apiState.getCourses = {
      ...defaultApiState,
      success: true
    };
    state.courses = data;
  },
  GET_COURSES_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.getCourses = {
      ...defaultApiState,
      error
    };
  },

  GET_COURSE_BY_SLUG_LOADING(state: CourseState) {
    state.apiState.getCourseBySlug = {
      ...defaultApiState,
      loading: true
    };
    state.courseBySlug = undefined;
  },
  GET_COURSE_BY_SLUG_SUCCESS(state: CourseState, data?: BaseCourse) {
    state.apiState.getCourseBySlug = {
      ...defaultApiState,
      success: true
    };
    state.courseBySlug = data ? data : undefined;
  },
  GET_COURSE_BY_SLUG_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.getCourseBySlug = {
      ...defaultApiState,
      error
    };
  },

  GET_FULL_COURSE_DETAILS_BY_SLUG_LOADING(state: CourseState) {
    state.apiState.getFullCourseDetailsBySlug = {
      ...defaultApiState,
      loading: true
    };
    state.publicCourseState.courseDetails = undefined;
  },
  GET_FULL_COURSE_DETAILS_BY_SLUG_SUCCESS(
    state: CourseState,
    data: BaseCourse
  ) {
    state.apiState.getFullCourseDetailsBySlug = {
      ...defaultApiState,
      success: true
    };
    state.publicCourseState.courseDetails = data;
  },
  GET_FULL_COURSE_DETAILS_BY_SLUG_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.getFullCourseDetailsBySlug = {
      ...defaultApiState,
      error
    };
  },

  GET_COURSE_DETAILS_LOADING(state: CourseState) {
    state.apiState.getCourseDetails = {
      ...defaultApiState,
      loading: true
    };
    state.courses = undefined;
  },
  GET_COURSE_DETAILS_SUCCESS(state: CourseState, data: CourseDetails) {
    state.apiState.getCourseDetails = {
      ...defaultApiState,
      success: true
    };
    state.courseDetails = data;
  },
  GET_COURSE_DETAILS_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.getCourseDetails = {
      ...defaultApiState,
      error
    };
  },

  CREATE_NEW_COURSE_LOADING(state: CourseState) {
    state.apiState.createNewCourse = {
      ...defaultApiState,
      loading: true
    };

    state.createdCourseId = undefined;
  },
  CREATE_NEW_COURSE_SUCCESS(state: CourseState, data: number) {
    state.apiState.createNewCourse = {
      ...defaultApiState,
      success: true
    };

    state.createdCourseId = data;
  },
  CREATE_NEW_COURSE_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.createNewCourse = {
      ...defaultApiState,
      error
    };
  },

  CREATE_DRAFT_COURSE_LOADING(state: CourseState) {
    state.apiState.createDraftCourse = {
      ...defaultApiState,
      loading: true
    };
    state.createdDraftCourseId = undefined;
  },
  CREATE_DRAFT_COURSE_SUCCESS(state: CourseState, data: number) {
    state.apiState.createDraftCourse = {
      ...defaultApiState,
      success: true
    };

    state.createdDraftCourseId = data;
  },
  CREATE_DRAFT_COURSE_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.createDraftCourse = {
      ...defaultApiState,
      error
    };
  },

  UPDATE_COURSE_LOADING(state: CourseState) {
    state.apiState.updateCourse = {
      ...defaultApiState,
      loading: true
    };
  },
  UPDATE_COURSE_SUCCESS(state: CourseState) {
    state.apiState.updateCourse = {
      ...defaultApiState,
      success: true
    };
  },
  UPDATE_COURSE_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.updateCourse = {
      ...defaultApiState,
      error
    };
  },

  UPDATE_COURSE_TYPE_LOADING(state: CourseState) {
    state.apiState.updateCourseType = {
      ...defaultApiState,
      loading: true
    };
  },
  UPDATE_COURSE_TYPE_SUCCESS(state: CourseState) {
    state.apiState.updateCourseType = {
      ...defaultApiState,
      success: true
    };
  },
  UPDATE_COURSE_TYPE_ERROR(state: CourseState, error: AxiosError) {
    state.apiState.updateCourseType = {
      ...defaultApiState,
      error
    };
  },

  GET_DEFAULT_COURSE_LEVEL_ATTRIBUTES_LOADING(state: CourseState) {
    state.apiState.getDefaultCourseLevelAttributes = {
      ...defaultApiState,
      loading: true
    };
    state.defaultCourseLevelAttributes = undefined;
  },
  GET_DEFAULT_COURSE_LEVEL_ATTRIBUTES_SUCCESS(
    state: CourseState,
    data: GroupLevelAttribute[]
  ) {
    state.apiState.getDefaultCourseLevelAttributes = {
      ...defaultApiState,
      success: true
    };
    state.defaultCourseLevelAttributes = data;
  },
  GET_DEFAULT_COURSE_LEVEL_ATTRIBUTES_ERROR(
    state: CourseState,
    error: AxiosError
  ) {
    state.apiState.getDefaultCourseLevelAttributes = {
      ...defaultApiState,
      error
    };
  },

  GET_REQUIRED_PUBLIC_COURSE_LEVEL_ATTRIBUTES_LOADING(state: CourseState) {
    state.apiState.getRequiredPublicCourseLevelAttributes = {
      ...defaultApiState,
      loading: true
    };
    state.requiredPublicCourseLevelAttributes = [];
  },
  GET_REQUIRED_PUBLIC_COURSE_LEVEL_ATTRIBUTES_SUCCESS(
    state: CourseState,
    data: GroupLevelAttribute[]
  ) {
    state.apiState.getRequiredPublicCourseLevelAttributes = {
      ...defaultApiState,
      success: true
    };
    state.requiredPublicCourseLevelAttributes = data;
  },
  GET_REQUIRED_PUBLIC_COURSE_LEVEL_ATTRIBUTES_ERROR(
    state: CourseState,
    error: AxiosError
  ) {
    state.apiState.getRequiredPublicCourseLevelAttributes = {
      ...defaultApiState,
      error
    };
  },

  /* Non-API States */
  STORE_LOCATION_ATTRIBUTE_CONFIG(
    state: CourseState,
    payload: GroupLevelAttributeOption[]
  ) {
    state.courseLevelAttributeState.locationGLAConfig = payload;
  },

  STORE_LIST_OF_CONTACTS(
    state: CourseState,
    payload: GroupLevelAttributeContactsType[]
  ) {
    state.courseLevelAttributeState.listOfContacts = payload;
  },

  UPDATE_COURSE_HAS_PACKAGES(state: CourseState, payload: boolean) {
    state.courseCreationState.hasPackages = payload;
  },

  UPDATE_COURSE_HAS_MODULES(state: CourseState, payload: boolean) {
    state.courseCreationState.hasModules = payload;
  },

  UPDATE_HAS_QUESTIONNAIRE(state: CourseState, payload: boolean) {
    state.courseCreationState.hasQuestionnaire = payload;
  },

  UPDATE_HAS_FREE_COURSE(state: CourseState, payload: boolean) {
    state.courseCreationState.isFreeCourse = payload;
  },

  UPDATE_SELECTED_COURSE_TYPE(state: CourseState, payload?: CourseTypeOption) {
    state.courseCreationState.selectedCourseType = payload;
  },

  SET_CURRENT_ACTIVE_TAB(state: CourseState, payload: CourseTabsNames) {
    state.courseTabState.activeTabName = payload;
  },

  SET_SHOULD_CREATE_WITH_LICENSE(state: CourseState, payload: boolean) {
    state.courseLicenseState.shouldCreateWithLicense = payload;
  },

  STORE_COURSE_SIZE(state: CourseState, payload: number) {
    state.courseCreationState.courseSize = payload;
  },

  STORE_START_DATE(state: CourseState, payload: string) {
    state.courseCreationState.courseStartDate = payload;
  },

  STORE_END_DATE(state: CourseState, payload: string) {
    state.courseCreationState.courseEndDate = payload;
  }
};
